export default __webpack_public_path__ + "static/media/blog-paver-walkway-001.dd6e66ae.jpg";